import { combineReducers } from 'redux';

// reducer import
import messageReducer from './messageReducer';
import notificationReducer from './notificationReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const slicesReducer = combineReducers({
  message: messageReducer,
  notification: notificationReducer,
});

export default slicesReducer;
